import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import MultiStepForm from './components/MultiStepForm';
import LandingPage from './components/LandingPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename="/wp-content/uploads/custom-forms/join-now/">
        <Routes>
          <Route path="/" element={<MultiStepForm />} />
          <Route path="/form" element={<MultiStepForm />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App; 